import React from 'react';
import PrimarySidebar from '../Sidebar/PrimarySidebar';
import { IoGridOutline } from 'react-icons/io5';
import { IoSettingsOutline } from 'react-icons/io5';
import { IoAnalyticsOutline } from 'react-icons/io5';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { ReactComponent as BriefcaseIcon } from '../../assets/images/briefcase.svg';
import { ReactComponent as FlagIcon } from '../../assets/images/flag.svg';
import { ReactComponent as ModelScenarioIcon } from '../../assets/images/model.svg';
import { ReactComponent as SmartBenchmarkIcon } from '../../assets/images/smart-benchmark.svg';
import { isAuthorized } from '../../app/userImpersonate';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export let routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <IoGridOutline />,
  },
  {
    path: '/my-disclosure',
    name: 'My Disclosure',
    icon: <BriefcaseIcon />,
  },
  {
    path: '/reduction-plan',
    name: 'Reduction Plan',
    icon: <FlagIcon />,
  },
  {
    path: '/model-scenarios',
    name: 'Model Scenarios',
    icon: <ModelScenarioIcon />,
  },
  {
    path: '/smart-benchmark',
    name: 'Smart Benchmark',
    icon: <SmartBenchmarkIcon />,
  },
  {
    path: '/admin',
    icon: <IoSettingsOutline />,
    name: 'Admin',
  },
  {
    path: '/rootadmin',
    icon: <IoSettingsOutline />,
    name: 'Root Admin'
  },
  {
    path: '/emissions',
    icon: <IoAnalyticsOutline />,
    name: 'Emission Data'
  },
  {
    path: '/reports',
    icon: <IoDocumentTextOutline />,
    name: 'Reports',
  },
];

const Main = (props) => {
  if (!isAuthorized(['cv_root'])) {
    routes = routes.filter((value) => {
      return value.path !== '/rootadmin';
    });
  }
  if (!isAuthorized(['cv_root', 'cv_admin'])) {
    routes = routes.filter((value) => {
      return value.path !== '/admin';
    });
  }

  if (isAuthorized(['cv_structured'])) {
    routes = routes.filter((value) => {
      return value.path !== "/reports" && value.path !== "/dashboard";
    });
  }

  const { usrOrgOptions } = props?.userInfo;
  if (!usrOrgOptions?.optOrgSectorEnabled) {
    routes = routes.filter((value) => {
      return value.path !== "/smart-benchmark";
    });
  }
  
  const { t } = useTranslation();
  return (
    <div className="d-flex flex-row mw-100">
      <PrimarySidebar items={routes} />
      <div className="offset-main">
        <div className="main-body">{props.children}</div>
        <footer className="main-footer">
          <Row>
            <Col xs={12} style={{ textAlign: "center" }}>
              <p className="text-muted" style={{ margin: 0, lineHeight: "40px" }}>
                <a href="https://simblegroup.com/carbonview-terms-and-conditions" className="text-muted">
                {t('Terms and Conditions')}
                </a>
              </p>
            </Col>
          </Row>
        </footer>
      </div>
    </div>
  );
};

export default Main;
